import store from 'shared/store';
import { createApp } from 'vue';
import { initFormKitSchema } from 'shared/utils/initFormKitSchema';
import DeliveryCheckout from './deliveryCheckout.vue';
import CheckoutModalLogin from 'multisite/components/checkout/checkoutModalLogin.vue';
import ProgressBar from 'shared/components/progressBar/progressBar.vue';
import '../Styles/_c-global-checkout.scss';

async function mountDeliveryInformationStepPage() {
	const globalCheckoutDeliveryStep = document.querySelector(
		'[data-feature="globalCheckoutDeliveryStep"]',
	);

	if (!globalCheckoutDeliveryStep) {
		console.warn('[deliveryInformationStepPage] Container not found');
		return;
	}

	const app = createApp({
		name: 'GlobalCheckoutDeliveryStep',
	});
	app.component('delivery-checkout', DeliveryCheckout);
	app.component('checkout-modal-login', CheckoutModalLogin);
	app.component('progress-bar', ProgressBar);
	await initFormKitSchema(app);
	app.use(store);
	app.mount(globalCheckoutDeliveryStep);
}

mountDeliveryInformationStepPage().catch((error) => {
	console.error('Error mounting deliveryInformationStepPage:', error);
});
